/* Public API Surface of mango-event-analytics */

// Export main module
export * from './lib/app.module';

// Export components
export * from './lib/app.component';

// Export services
export * from './lib/services/mango-event-analytics.service';

// Export interfaces and types
export * from './lib/interface';

